// useCustomFecthQuery.js - CORRECTED VERSION
import { useQuery } from "@tanstack/react-query";
import fetcher from "./fetcher";

/**
 * Custom hook for fetching data with React Query
 * @param {Array} key - Query key for caching
 * @param {string} url - API endpoint URL
 * @param {string} token - Auth token for requests
 * @param {Object} options - React Query options
 * @returns {Object} React Query result object
 */
function useCustomFetchQuery(key, url, token, options = {}) {
  return useQuery({
    queryKey: key,
    queryFn: () => fetcher(url, token),
    ...options,
  });
}

export default useCustomFetchQuery;